import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import { ConfigProvider, App as AntdApp } from 'antd';
import 'dayjs/locale/ru';
import locale from 'antd/locale/ru_RU';
import updateLocale from 'dayjs/plugin/updateLocale';
import dayjs from 'dayjs';
import './index.css';
import * as Sentry from '@sentry/browser';
import { ADMIN_SENTRY_DSN } from './config/config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { notificationService } from './notification-service';

if (ADMIN_SENTRY_DSN) {
  Sentry.init({ dsn: ADMIN_SENTRY_DSN });
}

dayjs.extend(updateLocale);
dayjs.updateLocale('ru_RU', {
  weekStart: 4,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();
serviceWorkerRegistration.register();
notificationService.subscribeToPushEvents();

root.render(
  <QueryClientProvider client={queryClient}>
    <AntdApp>
      <ConfigProvider locale={locale}>
        <App />
      </ConfigProvider>
    </AntdApp>
  </QueryClientProvider>,
);
